import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const footerLinks = {
    servicios: [
      { label: 'Redes de Datos y WiFi', id: 'services' },
      { label: 'Seguridad Tecnológica', id: 'services' },
      { label: 'Desarrollo de Software', id: 'services' },
      { label: 'Soporte Técnico', id: 'services' },
      { label: 'Venta de Equipos', id: 'services' }
    ],
    empresa: [
      { label: 'Sobre Nosotros', id: 'about' },
      { label: 'Testimonios', id: 'testimonials' },
      { label: 'Contacto', id: 'contact' }
    ]
  };

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Instagram, href: '#', label: 'Instagram' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 lg:px-8 py-12 md:py-16">
        {/* Contact Info - Centered */}
        <div className="text-center mb-12">
          <p className="text-gray-400 leading-relaxed mb-6 max-w-2xl mx-auto">
            Somos especialistas en soluciones tecnológicas integrales para empresas y particulares.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-6 text-gray-400">
            <div className="flex items-center justify-center space-x-2">
              <Mail size={18} className="flex-shrink-0" />
              <span className="text-sm">contacto@solutionit.cl</span>
            </div>
            <div className="flex items-center justify-center space-x-2">
              <Phone size={18} className="flex-shrink-0" />
              <span className="text-sm">+56 9 6618 6986</span>
            </div>
            <div className="flex items-center justify-center space-x-2">
              <MapPin size={18} className="flex-shrink-0" />
              <span className="text-sm">Viña del Mar, Chile</span>
            </div>
          </div>
        </div>

        {/* Links Grid - Centered */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 max-w-4xl mx-auto">

          {/* Services Links */}
          <div className="text-center">
            <h3 className="text-lg font-bold mb-4">Servicios</h3>
            <ul className="space-y-2">
              {footerLinks.servicios.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div className="text-center">
            <h3 className="text-lg font-bold mb-4">Empresa</h3>
            <ul className="space-y-2">
              {footerLinks.empresa.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              &copy; {currentYear} SolutionIT. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                Política de Privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                Términos de Servicio
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
